/* ***
  TODO: delete this file once translations are are fully migrated
*** */

import React from 'react';
import { IntlProvider } from 'react-intl';
import { locale, messages } from 'helpers/intl-helper';

// DefaultRichTextElement Components are used with IntlProvider
// https://formatjs.io/docs/react-intl/components/#defaultrichtextelements
const DefaultRichTextElementStrong = (chunks: React.ReactNode) => {
  return <strong>{chunks}</strong>;
};

const DefaultRichTextElementParagraph = (chunks: React.ReactNode) => {
  return <p>{chunks}</p>;
};

function TranslationsProvider({ children }: { children: React.ReactNode }) {
  return (
    <IntlProvider
      locale={locale}
      defaultLocale="en"
      key={locale}
      messages={messages}
      textComponent="span"
      defaultRichTextElements={{
        strong: DefaultRichTextElementStrong,
        p: DefaultRichTextElementParagraph,
      }}
    >
      {children}
    </IntlProvider>
  );
}

export default TranslationsProvider;
